import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useTranslation } from '@lt/localization';
import Preloader from '../../../../components/Preloader';
import { numToWords } from '../../../../utils/stringUtils';
import { formatDateToDayShort } from '../../../../utils/dateUtils';

const ShortInfoPreloader = ({
  startDate,
  endDate,
  touristsCount,
  baseCls,
  hasAdjustParams,
  isMobile,
}) => {
  const from = formatDateToDayShort(startDate);
  const to = formatDateToDayShort(endDate);

  const { t } = useTranslation();
  const tourists = numToWords(touristsCount);
  const title = hasAdjustParams
    ? t('checkout.shortInfo.find')
    : t('checkout.shortInfo.check');

  return (
    <div className={`${baseCls} ${baseCls}--preload`}>
      <Preloader
        className={cn(
          `${baseCls}__throbber`,
          isMobile ? null : `${baseCls}__throbber--with-margin`,
        )}
      />

      <h1 className={`${baseCls}__title`}>
        {title}
        <br />
        {t('checkout.shortInfo.startDate')}&nbsp;
        <span className="nowrap">{`${from} — ${to}, ${t(
          'filters.prices.title_on',
        )} ${tourists}`}</span>
      </h1>
    </div>
  );
};

ShortInfoPreloader.propTypes = {
  touristsCount: PropTypes.number.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  baseCls: PropTypes.string.isRequired,
  hasAdjustParams: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
};

ShortInfoPreloader.defaultProps = {
  isMobile: false,
};

export default ShortInfoPreloader;
